import React from "react";
import "./Dashboard.css";

/**
 * EntityCardSkeleton - Skeleton loader for entity cards
 */
export const EntityCardSkeleton = () => {
  return (
    <div className="entity-card-skeleton">
      <div className="row align-items-center">
        {/* Logo Skeleton */}
        <div className="col-auto">
          <div className="skeleton-animate skeleton-logo"></div>
        </div>

        {/* Info Skeleton */}
        <div className="col">
          <div className="skeleton-animate skeleton-text-lg"></div>
          <div className="skeleton-animate skeleton-text-sm"></div>
        </div>

        {/* Stats Skeleton */}
        <div className="col-auto d-none d-lg-flex" style={{ gap: "24px" }}>
          <div className="skeleton-animate skeleton-stat"></div>
          <div className="skeleton-animate skeleton-stat"></div>
        </div>

        {/* Actions Skeleton */}
        <div className="col-auto">
          <div className="skeleton-animate skeleton-btn"></div>
        </div>
      </div>
    </div>
  );
};

/**
 * EntityCardSkeletonList - Renders multiple skeleton cards
 * @param {number} count - Number of skeleton cards to render
 */
export const EntityCardSkeletonList = ({ count = 5 }) => {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <EntityCardSkeleton key={index} />
      ))}
    </>
  );
};

export default EntityCardSkeleton;
